// extracted by mini-css-extract-plugin
export default {"ago":"TimeAgo_ago__FVNnB","dayTotal":"TimeAgo_dayTotal__AC1Ex","value":"TimeAgo_value__LCoPT"};